export enum TimeOption {
    AnyTime = 'AnyTime',
    CustomTime = 'CustomTime',
}
